import React from 'react'
import "./Header.css"
import { Container } from 'react-bootstrap'
import header from "../../assets/header.png";
function Header() {
  return (
    <div className=' header_container'>
  <Container className='h-100'>
    <div className='d-flex justify-content-center flex-column align-items-center h-100'>
<h4 className='text-center text-white mb-4 pb-2'>البرنامج التدريبي الإلكتروني</h4>
<p className='text-center text-white'> 
  البرنامج التدريبي الإلكتروني لأنهاء متطلبات رسالة الماجستير بعنوان فعاليه برنامج تدريبي إلكتروني قائم على الفيديو التفاعلي لتنميه مهارات المواطنه الرقميه لأخصائي مصادر التعلم بسلطنة عمان
  
</p>
<p className='text-center text-white mb-1'> 
  عمل  :أ. سالم الحكماني
</p>
<p className='text-center text-white mb-1'> 
اشراف : د. سامي المزورعي 
</p>
<p className='text-center text-white mb-1'> 
د. حمود الحسني
</p>
{/* <img src={header}alt=''className='w-100 h-100'/> */}
      </div>
  </Container>
    </div>
  )
}

export default Header